import React from "react";

import { copy } from "shared/assets";
import { Mail, Phone, Globe } from "shared/assets/icons";
import { FancyAnchorLink } from "shared/components";
import { IconWithText, Icon, MutedText } from "shared/styles";
import { formatPhone } from "shared/utils";
import { IContactInfo } from "Venues/types";
import { ContactInfoContainer } from "./styles";

interface ContactInfoProps extends IContactInfo {
  showPlaceholder?: boolean;
}

const { placeholder } = copy;

export const ContactInfo: React.FC<ContactInfoProps> = ({
  website,
  email,
  phone,
  showPlaceholder,
}) => {
  const items = [
    {
      key: "website",
      label: website,
      href: website,
      icon: Globe,
      placeholder: placeholder.website,
    },
    {
      key: "email",
      label: email,
      href: `mailto:${email}`,
      icon: Mail,
      placeholder: placeholder.mail,
    },
    {
      key: "phone",
      label: phone?.number ? formatPhone(phone) : "",
      href: phone?.number ? `tel:${formatPhone(phone)}` : "",
      icon: Phone,
      placeholder: placeholder.phone,
    },
  ];

  return (
    <ContactInfoContainer>
      {items.map(({ key, label, href, icon, placeholder }) => (
        <React.Fragment key={key}>
          {(label || showPlaceholder) && (
            <IconWithText>
              <Icon as={icon} />
              {label && href ? (
                <FancyAnchorLink href={href} target="_blank" rel="noreferrer">
                  <span>{label}</span>
                </FancyAnchorLink>
              ) : (
                <MutedText>{placeholder}</MutedText>
              )}
            </IconWithText>
          )}
        </React.Fragment>
      ))}
    </ContactInfoContainer>
  );
};
